import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { storage } from '../firebase-config'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
// import edit from '../assets/edit.png'
import heic2any from "heic2any";
import Upload from '../assets/Upload.png'
import CloseIcon from '../assets/CloseIcon.png'
import PdfIcon from '../assets/pdf.png'

export const randomString = (length = 30) => [...Array(length)].map(() => Math.random().toString(36)[2]).join('')

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '40px 0px',
    borderWidth: 2,
    borderRadius: 2,
    position: 'relative',
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    // maxWidth: '300px',
    margin: 'auto',
    marginBottom: '20px'
};

const focusedStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};

export default function MyDropzone({ storageLocation, addMarginTop, errors, name, editing, images, updateImage, allowPdf = true, disabled }) {
    const [editingImage, setEditingImage] = useState(false)


    const uploadImage = (file) => {

        // const file = acceptedFiles[0]

        const size = (file.size / 1000000)
        const extension = file.type.replace('image/', '').replace('application/', '')

        if (extension === 'heic' || extension === 'heif') {
            return heic2any({
                blob: file,  // Use the original file object
                toType: "image/jpeg",
                quality: 0.7, // adjust quality as needed
            }).then(outputBlob => {
                const fileNew = new File([outputBlob], "heic" + ".jpg", { type: "image/jpeg", lastModified: new Date().getTime() });
                return doUploadFile(fileNew, extension, size)
            })
        } else {
            return doUploadFile(file, extension, size)
        }
    }
    const onDrop = useCallback(async acceptedFiles => {
        // Do something with the files
        // console.log('acceptedFiles', acceptedFiles)

        if (disabled) {
            return
        }

        let tempUrls = images
        for (let index = 0; index < acceptedFiles.length; index++) {
            const url1 = await uploadImage(acceptedFiles[index])
            tempUrls.push(url1)
        }

        updateImage([...tempUrls])
    }, [images])


    const doUploadFile = (file, extension, size) => {
        const mountainsRef = ref(storage, `${storageLocation}/${randomString()}.${extension}`);

        return uploadBytes(mountainsRef, file).then((snapshot) => {
            console.log('Uploaded a blob or file!');
            return getDownloadURL(snapshot.ref).then((downloadURL) => {
                console.log('File available at', downloadURL);
                // updateImage(downloadURL)
                return ({ extension, url: downloadURL, name, size })
                // setEditingImage(false)
            })
        })
    }

    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject
    } = useDropzone({ accept: allowPdf ? { 'image/*': [], 'application/pdf': [] } : { 'image/*': [] }, onDrop });


    const style = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ])



    useEffect(() => {
        if (editing && !editingImage) {
            setEditingImage(true)
        }
    }, [editing])


    useEffect(() => {
        if (errors.map(({ name }) => name).includes(name)) {
            document.getElementById(name).classList.add('errorImage')
        } else {
            document.getElementById(name).classList.remove('errorImage')
        }
    }, [errors])


    return (<>
        <div id={name} className="image-container" style={addMarginTop ? { marginTop: '20px' } : {}}>
            <div className='image-upload' {...getRootProps({ style })}>

                <input disabled={disabled} {...getInputProps()} />
                <img src={Upload} style={{ width: '42px', height: '31px', marginBottom: '10px' }} />
                <label style={{ textAlign: 'center' }}>Drag all required image or pdf files here or browse your files to upload</label>
            </div>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginTop: '20px' }}>
            {images.map(({ url: image, extension }, index) => <div key={image} style={{ position: 'relative', width: '100px', height: '100px', marginBottom: '10px', border: '1px solid #DEDEDE', padding: '10px', borderRadius: '12px' }}>
                <img src={CloseIcon} style={{ width: '14px', height: '14px', position: 'absolute', right: '10px', top: '10px' }} onClick={() => { updateImage(images.filter((r, idx) => idx !== index)) }} />
                <img src={(extension === 'pdf') ? PdfIcon : image} key={image} style={{ width: '100px', height: '100px', }} />
            </div>)}
        </div>
    </>)
}